const clamp = (min, max, value) => Math.min(max, Math.max(min, value));

export default clamp;
